<template>
  <div class="page-wrapper">
    <div class="page-title">
      <CIcon name="cil-pencil" /> Edit Case
      <span class="page-title-badge" v-if="selected.caseNumber">{{ selected.caseNumber }}</span>
    </div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol sm="6">
                <h4 id="traffic" class="card-title mb-0">Case Identity</h4>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <!-- Case Status & Lock Info (Non-Admins) -->
            <CRow v-if="selected.isClosed">
              <CCol sm="12">
                <CAlert color="danger" class="mb-3">
                  <CIcon name="cil-lock-locked" /> <strong>Case Locked:</strong> This case is closed. Edits are restricted for non-admin users.
                </CAlert>
              </CCol>
            </CRow>
            <CRow v-else-if="$store.state.user.role !== 'Admin' && $store.state.user.role !== 'subadmin' && $store.state.user.role !== 'Editor' && selected.editExtensionUntil">
              <CCol sm="12">
                <CAlert color="info" class="mb-3">
                  <CIcon name="cil-clock" /> <strong>Edit Extension Active!</strong> You can edit this case until <strong>{{ new Date(selected.editExtensionUntil).toLocaleString() }}</strong>.
                </CAlert>
              </CCol>
            </CRow>

            <!-- Admin Case Controls -->
            <template v-if="$store.state.user.role === 'Admin' || $store.state.user.role === 'subadmin' || $store.state.user.role === 'Editor'">
              <CRow>
                <CCol sm="12">
                  <CAlert :color="selected.isClosed ? 'danger' : 'success'" class="mb-3 d-flex justify-content-between align-items-center border-2">
                    <div>
                      <span v-if="selected.isClosed" class="h5 mb-0"><CIcon name="cil-lock-locked" /> Record Status: <strong>CLOSED</strong></span>
                      <span v-else class="h5 mb-0"><CIcon name="cil-lock-unlocked" /> Record Status: <strong>OPEN</strong></span>
                    </div>
                    <CButton size="sm" :color="selected.isClosed ? 'success' : 'dark'" @click="toggleCaseStatus">
                      <CIcon :name="selected.isClosed ? 'cil-lock-unlocked' : 'cil-lock-locked'" />
                      {{ selected.isClosed ? 'Re-open Case' : 'Close & Lock Case' }}
                    </CButton>
                  </CAlert>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6">
                  <CInput
                    label="Edit Window Extension (Date & Time)"
                    type="datetime-local"
                    v-model="selected.editExtensionUntil"
                    description="Users can edit this case until this specific date and time."
                  />
                </CCol>
              </CRow>
            </template>
            <CRow v-if="selected.approvalStatus === 'rejected'">
              <CCol sm="12">
                <CAlert color="danger" class="mb-3">
                  <strong>Rejected Case!</strong><br />
                  Reason: {{ selected.rejectionReason || 'No reason provided.' }}
                </CAlert>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <CInput
                  label="Case Number"
                  type="text"
                  :disabled="true"
                  :value="selected.caseNumber"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  label="Date Added"
                  type="text"
                  :disabled="true"
                  :value="new Date(selected.dateAdded).toDateString()"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="4">
                <CForm>
                  <CSelect
                    label="Class"
                    placeholder="Select a one"
                    :options="options.class"
                    :value.sync="selected.class"
                    @change="updateFilters('family')"
                  />
                </CForm>
              </CCol>
              <CCol sm="4">
                <CForm>
                  <CSelect
                    label="Family Name"
                    placeholder="Select a one"
                    :options="options.family"
                    :value.sync="selected.family"
                    @change="updateFilters('group')"
                  />
                </CForm>
              </CCol>
              <CCol sm="4">
                <CForm>
                  <CSelect
                    label="Group Name"
                    placeholder="Select a one"
                    :options="options.group"
                    :value.sync="selected.group"
                    @change="updateFilters('identity')"
                  />
                </CForm>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <CForm>
                  <CSelect
                    label="Identity Name"
                    placeholder="Select an one"
                    :options="options.identity"
                    :value.sync="selected.identity"
                    @change="updateIdentityNames('identity')"
                  />
                </CForm>
                <i v-if="selected.class == null">
                  Available Indentiy Name:
                  <strong class="text-danger">{{
                    selected.identityName
                  }}</strong>
                </i>
              </CCol>
              <CCol sm="6">
                <CForm>
                  <CSelect
                    label="Scientific Name"
                    placeholder="Select an one"
                    :options="options.scientific"
                    :value.sync="selected.scientific"
                    @change="updateIdentityNames('scientific')"
                  />
                </CForm>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="text-center">
            <CRow>
              <CCol sm="3">
                <CButton type="submit" color="danger" @click="deleteReport()">
                  <CIcon name="cil-trash" /> Delete Record
                </CButton>
              </CCol>
              <CCol sm="3" class="text-center">
                <div>
                  <pulse-loader :loading="loading" color="#2E7D32"></pulse-loader>
                </div>
              </CCol>
              <CCol sm="4" v-if="selected.isMobileCase && selected.approvalStatus !== 'approved'" class="d-flex justify-content-between">
                <CButton type="submit" color="success" style="width: 48%;" @click="updateApprovalStatus('approved')">
                  <CIcon name="cil-check" /> Approve
                </CButton>
                <CButton type="submit" color="warning" style="width: 48%;" @click="updateApprovalStatus('rejected')">
                  <CIcon name="cil-x" /> Reject
                </CButton>
              </CCol>
              <CCol :sm="(!selected.isMobileCase || selected.approvalStatus === 'approved') ? 6 : 2">
                <CButton type="submit" color="primary" @click="updateReport()">
                  <CIcon name="cil-check-circle" /> Save & Update
                </CButton>
              </CCol>
            </CRow>
          </CCardFooter>
        </CCard>
      </CCol>

      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol sm="6">
                <h4 id="traffic" class="card-title mb-0">
                  Rescue and Admission Details
                </h4>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="6">
                <CForm>
                  <CSelect
                    label="Rescue Type"
                    placeholder="Select an option"
                    :options="options.rescueType"
                    :value.sync="selected.rescueType"
                  />
                </CForm>
              </CCol>
              <CCol sm="6">
                <CInput
                  label="Date of Rescue"
                  type="date"
                  :value="selected.dateOfRescue"
                  v-model="selected.dateOfRescue"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="6" class="position-relative" ref="rescueSearchCol">
                <!-- <CInput label="Place of Rescue" type="text" :value="selected.placeOfRescue"
                                    v-model="selected.placeOfRescue" /> -->
                <CInput
                  label="Place of Rescue"
                  type="text"
                  v-model="selected.placeOfRescue"
                  @input="onInputrescue"
                  @focus="onInputrescue"
                />
                <ul v-if="suggestionsrescue.length && selected.placeOfRescue" class="suggestions-dropdown">
                  <li
                    v-for="suggestions in suggestionsrescue"
                    :key="suggestions"
                    @click="selectSuggestionrescue(suggestions)"
                    class="suggestion-item"
                  >
                    {{ suggestions }}
                  </li>
                </ul>
              </CCol>
              <CCol sm="6">
                <CInput
                  label="District or Sub-Division"
                  type="text"
                  :value="selected.districtSubDivision"
                  v-model="selected.districtSubDivision"
                />
              </CCol>

              <CCol sm="6">
                <CSelect
                  label="First attended By"
                  placeholder="Select an option"
                  :options="options.rescuedBy"
                  :value.sync="selected.rescuedBy"
                />
              </CCol>
              <CCol sm="6">
                <CSelect
                  label="First brought By"
                  placeholder="Select an option"
                  :options="options.broughtBy"
                  :value.sync="selected.broughtBy"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="6">
                <CInput
                  label="GPS Lattitude (Eg: 27.098499)"
                  type="number"
                  :value="selected.gpsLatitudeRescue"
                  v-model="selected.gpsLatitudeRescue"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  label="GPS Longitude (Eg: 76.098499)"
                  type="number"
                  :value="selected.gpsLongditudeRescue"
                  v-model="selected.gpsLongditudeRescue"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12">
                <CForm>
                  <CSelect
                    label="Cause of Displacement"
                    placeholder="Select an option"
                    :options="options.causeOfDisp"
                    :value.sync="selected.displacement"
                  />
                </CForm>
              </CCol>
              <CCol sm="12" v-if="selected.displacement === 'Others'">
                <CForm>
                  <CInput
                    label="Other Reason For Cause of Displacement"
                    type="text"
                    :value="selected.otherreason"
                    v-model="selected.otherreason"
                  />
                </CForm>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="6">
                <CSelect
                  label="Zone of origin"
                  :options="options.zones"
                  :disabled="isOldCase"
                  placeholder="Select an option"
                  :value.sync="selected.zoneName"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  label="Date of Admission"
                  type="date"
                  :value="selected.dateOfAdmission"
                  v-model="selected.dateOfAdmission"
                  @change="validateDates"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12">
                <CSelect
                  label="Case Type"
                  :options="options.rescueMode"
                  placeholder="Select an option"
                  :value.sync="selected.rescueMode"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <CInput
                  label="Date of Second Admission"
                  type="date"
                  :value="selected.dateOfSecondAdmission"
                  v-model="selected.dateOfSecondAdmission"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  label="Place of Second Admission"
                  type="text"
                  :value="selected.placeOfSecondAdmission"
                  v-model="selected.placeOfSecondAdmission"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="text-center">
            <CRow>
              <CCol sm="3">
                <CButton type="submit" color="danger" @click="deleteReport()">
                  <CIcon name="cil-trash" /> Delete Record
                </CButton>
              </CCol>
              <CCol sm="3" class="text-center">
                <div>
                  <pulse-loader :loading="loading" color="#2E7D32"></pulse-loader>
                </div>
              </CCol>
              <CCol sm="4" v-if="selected.isMobileCase && selected.approvalStatus !== 'approved'" class="d-flex justify-content-between">
                <CButton type="submit" color="success" style="width: 48%;" @click="updateApprovalStatus('approved')">
                  <CIcon name="cil-check" /> Approve
                </CButton>
                <CButton type="submit" color="warning" style="width: 48%;" @click="updateApprovalStatus('rejected')">
                  <CIcon name="cil-x" /> Reject
                </CButton>
              </CCol>
              <CCol :sm="(!selected.isMobileCase || selected.approvalStatus === 'approved') ? 6 : 2">
                <CButton type="submit" color="primary" @click="updateReport()">
                  <CIcon name="cil-check-circle" /> Save & Update
                </CButton>
              </CCol>
            </CRow>
          </CCardFooter>
        </CCard>
      </CCol>

      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol sm="6">
                <h4 id="traffic" class="card-title mb-0">Animal Details</h4>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="6">
                <CInput
                  label="Age (years)"
                  type="number"
                  :disabled="false"
                  :value="selected.ageYears"
                  v-model="selected.ageYears"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  label="Age (Months)"
                  type="number"
                  :disabled="false"
                  :value="selected.ageMonths"
                  v-model="selected.ageMonths"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6" v-if="selected.class == 'mammals'">
                <CSelect
                  label="Stage"
                  :options="options.mammals"
                  placeholder="Select an option"
                  :value.sync="selected.stage"
                />
              </CCol>
              <CCol sm="6" v-else-if="selected.class == 'aves'">
                <CSelect
                  label="Stage"
                  :options="options.aves"
                  placeholder="Select an option"
                  :value.sync="selected.stage"
                />
              </CCol>
              <CCol sm="6" v-else>
                <CSelect
                  label="Stage"
                  :options="options.reptiles"
                  placeholder="Select an option"
                  :value.sync="selected.stage"
                />
              </CCol>
              <CCol sm="6">
                <CSelect
                  label="Sex"
                  :options="options.sex"
                  placeholder="Select an option"
                  :value.sync="selected.sex"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="6">
                <CInput
                  label="Body Weight"
                  type="text"
                  :value="selected.weight"
                  v-model="selected.weight"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  label="Length"
                  type="text"
                  :value="selected.length"
                  v-model="selected.length"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="text-center">
            <CRow>
              <CCol sm="3">
                <CButton type="submit" color="danger" @click="deleteReport()">
                  <CIcon name="cil-trash" /> Delete Record
                </CButton>
              </CCol>
              <CCol sm="3" class="text-center">
                <div>
                  <pulse-loader :loading="loading" color="#2E7D32"></pulse-loader>
                </div>
              </CCol>
              <CCol sm="4" v-if="selected.isMobileCase && selected.approvalStatus !== 'approved'" class="d-flex justify-content-between">
                <CButton type="submit" color="success" style="width: 48%;" @click="updateApprovalStatus('approved')">
                  <CIcon name="cil-check" /> Approve
                </CButton>
                <CButton type="submit" color="warning" style="width: 48%;" @click="updateApprovalStatus('rejected')">
                  <CIcon name="cil-x" /> Reject
                </CButton>
              </CCol>
              <CCol :sm="(!selected.isMobileCase || selected.approvalStatus === 'approved') ? 6 : 2">
                <CButton type="submit" color="primary" @click="updateReport()">
                  <CIcon name="cil-check-circle" /> Save & Update
                </CButton>
              </CCol>
            </CRow>
          </CCardFooter>
        </CCard>
      </CCol>

      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol sm="6">
                <h4 id="traffic" class="card-title mb-0">Outcome</h4>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="8">
                <CSelect
                  label="Final Disposition (Outcome) "
                  :options="options.outcomes"
                  placeholder="Select an option"
                  :value.sync="selected.finalDisposition"
                />
              </CCol>
              <CCol
                sm="4"
                v-if="selected.finalDisposition != 'Pending under care'"
              >
                <CInput
                  label="Date of Outcome"
                  type="date"
                  :value="selected.dateOfOutcome"
                  v-model="selected.dateOfOutcome"
                  @change="validateDates"
                />
              </CCol>
            </CRow>
            <CRow v-if="selected.finalDisposition == 'Released'">
              <CCol sm="6">
                <CInput
                  label="GPS Release Lattitude (Eg: 27.098499)"
                  type="number"
                  :value="selected.gpsLatRelease"
                  v-model="selected.gpsLatRelease"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  label="GPS Release Longitude (Eg: 76.098499)"
                  type="number"
                  :value="selected.gpsLongRelease"
                  v-model="selected.gpsLongRelease"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label="Remarks"
                  type="text"
                  :value="selected.remarks"
                  v-model="selected.remarks"
                />
              </CCol>
            </CRow>
            <CRow>
              <!-- <CCol sm="12">
                                <CInput label="Place of Outcome" type="text" v-model="selected.placeOfOutcome" />
                            </CCol> -->
              <CCol sm="12" class="position-relative" ref="outcomeSearchCol">
                <CInput
                  label="Place of Outcome"
                  type="text"
                  v-model="selected.placeOfOutcome"
                  @input="onInput"
                  @focus="onInput"
                />
                <ul v-if="suggestions.length && selected.placeOfOutcome" class="suggestions-dropdown">
                  <li
                    v-for="suggestion in suggestions"
                    :key="suggestion"
                    @click="selectSuggestion(suggestion)"
                    class="suggestion-item"
                  >
                    {{ suggestion }}
                  </li>
                </ul>
              </CCol>
              <!-- <CCol sm="6">
                            <CTextarea
                                label="Reason of outcome"
                                type="text"
                                :value="selected.outcomeNotes"
                                v-model="selected.outcomeNotes"
                            />
                        </CCol> -->
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label="Reason of outcome"
                  type="text"
                  :value="selected.outcomeNotes"
                  v-model="selected.outcomeNotes"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <CSelect
                  label="Tagging methods"
                  :options="options.taggingMethods"
                  placeholder="Select an option"
                  :value.sync="selected.taggingMethods"
                />
              </CCol>
              <CCol sm="6">
                <CSelect
                  label="Collar"
                  :options="options.collar"
                  placeholder="Select an option"
                  :value.sync="selected.collar"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <CSelect
                  label="Radio-collar type"
                  :options="options.radioCollarType"
                  placeholder="Select an option"
                  :value.sync="selected.radioCollarType"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  label="Microchip number"
                  type="text"
                  v-model="selected.microchipNumber"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CSelect
                  label="Post-release monitoring"
                  :options="options.postReleaseMonitoring"
                  placeholder="Select an option"
                  :value.sync="selected.postReleaseMonitoring"
                />
              </CCol>
            </CRow>
            <CRow v-if="selected.postReleaseMonitoring === 'Done'">
              <CCol sm="6">
                <CInput
                  label="Time span of monitoring"
                  type="text"
                  v-model="selected.timeSpanOfMonitoring"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  label="Outcome of monitoring"
                  type="text"
                  v-model="selected.outcomeOfMonitoring"
                />
              </CCol>
            </CRow>
            <CRow v-if="selected.finalDisposition === 'DoA' || selected.finalDisposition === 'DUC'">
              <CCol sm="12">
                <CTextarea
                  label="Post-mortem result"
                  type="text"
                  v-model="selected.postMortemResult"
                />
              </CCol>
              <CCol sm="12">
                <CInputFile
                  label="Upload PM report"
                  @change="handlePostMortemReportUpload"
                  accept=".pdf,.doc,.docx"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="text-center">
            <CRow>
              <CCol sm="3">
                <CButton type="submit" color="danger" @click="deleteReport()">
                  <CIcon name="cil-trash" /> Delete Record
                </CButton>
              </CCol>
              <CCol sm="3" class="text-center">
                <div>
                  <pulse-loader :loading="loading" color="#2E7D32"></pulse-loader>
                </div>
              </CCol>
              <CCol sm="4" v-if="selected.isMobileCase && selected.approvalStatus !== 'approved'" class="d-flex justify-content-between">
                <CButton type="submit" color="success" style="width: 48%;" @click="updateApprovalStatus('approved')">
                  <CIcon name="cil-check" /> Approve
                </CButton>
                <CButton type="submit" color="warning" style="width: 48%;" @click="updateApprovalStatus('rejected')">
                  <CIcon name="cil-x" /> Reject
                </CButton>
              </CCol>
              <CCol :sm="(!selected.isMobileCase || selected.approvalStatus === 'approved') ? 6 : 2">
                <CButton type="submit" color="primary" @click="updateReport()">
                  <CIcon name="cil-check-circle" /> Save & Update
                </CButton>
              </CCol>
            </CRow>
          </CCardFooter>
        </CCard>
        <CCard class="mt-4">
          <CCardHeader>
            <CRow>
              <CCol sm="6">
                <h4 id="traffic" class="card-title mb-0">Photographs</h4>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <h5>Existing Photographs</h5>
                <div v-if="selected.photographs && selected.photographs.length > 0">
                  <CRow>
                    <CCol sm="3" v-for="(photo, index) in selected.photographs" :key="index">
                      <img :src="baseURL + 'images/' + photo" class="img-fluid mb-2" />
                    </CCol>
                  </CRow>
                </div>
                <div v-else>
                  <p>No photographs uploaded yet.</p>
                </div>
              </CCol>
            </CRow>
            <hr>
            <CRow>
              <CCol sm="12">
                <h5>Upload New Photographs</h5>
                <CInputFile
                  label="Photographs (minimum 2 in total)"
                  multiple
                  @change="handlePhotoUpload"
                  accept="image/*"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="text-center">
            <CRow>
              <CCol sm="3">
                <CButton type="submit" color="danger" @click="deleteReport()">
                  <CIcon name="cil-trash" /> Delete Record
                </CButton>
              </CCol>
              <CCol sm="3" class="text-center">
                <div>
                  <pulse-loader :loading="loading" color="#2E7D32"></pulse-loader>
                </div>
              </CCol>
              <CCol sm="4" v-if="selected.isMobileCase && selected.approvalStatus !== 'approved'" class="d-flex justify-content-between">
                <CButton type="submit" color="success" style="width: 48%;" @click="updateApprovalStatus('approved')">
                  <CIcon name="cil-check" /> Approve
                </CButton>
                <CButton type="submit" color="warning" style="width: 48%;" @click="updateApprovalStatus('rejected')">
                  <CIcon name="cil-x" /> Reject
                </CButton>
              </CCol>
              <CCol :sm="(!selected.isMobileCase || selected.approvalStatus === 'approved') ? 6 : 2">
                <CButton type="submit" color="primary" @click="updateReport()">
                  <CIcon name="cil-check-circle" /> Save & Update
                </CButton>
              </CCol>
            </CRow>
          </CCardFooter>
        </CCard>
      </CCol>

      <CCol md="3">
        <CCard>
          <CCardHeader>
            <h4 class="card-title mb-0">Case Timeline</h4>
          </CCardHeader>
          <CCardBody class="p-0">
            <ul class="timeline-list p-3">
              <li class="timeline-item mb-3" v-if="selected.dateAdded">
                <div class="timeline-icon bg-info">
                  <CIcon name="cil-plus" size="sm"/>
                </div>
                <div class="timeline-content">
                  <div class="timeline-title">Created</div>
                  <div class="timeline-date">{{ new Date(selected.dateAdded).toLocaleString('en-IN', { timeZone: 'UTC' }) }}</div>
                  <div class="timeline-user" v-if="selected.createdBy">By: {{ selected.createdBy.name }}</div>
                </div>
              </li>
              <li class="timeline-item mb-3" v-if="selected.approvedAt">
                <div class="timeline-icon bg-success">
                  <CIcon name="cil-check" size="sm"/>
                </div>
                <div class="timeline-content">
                  <div class="timeline-title">Approved</div>
                  <div class="timeline-date">{{ new Date(selected.approvedAt).toLocaleString('en-IN', { timeZone: 'UTC' }) }}</div>
                  <div class="timeline-user" v-if="selected.approvedBy">By: {{ selected.approvedBy.name }}</div>
                </div>
              </li>
              <li class="timeline-item mb-3" v-if="selected.lastUpdatedAt">
                <div class="timeline-icon bg-warning text-dark">
                  <CIcon name="cil-pencil" size="sm"/>
                </div>
                <div class="timeline-content">
                  <div class="timeline-title">Last Edited</div>
                  <div class="timeline-date">{{ new Date(selected.lastUpdatedAt).toLocaleString('en-IN', { timeZone: 'UTC' }) }}</div>
                  <div class="timeline-user" v-if="selected.lastUpdatedBy">By: {{ selected.lastUpdatedBy.name }}</div>
                </div>
              </li>
              <li class="timeline-item mb-3" v-if="selected.isClosed && selected.closedAt">
                <div class="timeline-icon bg-danger">
                  <CIcon name="cil-lock-locked" size="sm"/>
                </div>
                <div class="timeline-content">
                  <div class="timeline-title">Closed</div>
                  <div class="timeline-date">{{ new Date(selected.closedAt).toLocaleString('en-IN', { timeZone: 'UTC' }) }}</div>
                  <div class="timeline-user" v-if="selected.closedBy">By: {{ selected.closedBy.name }}</div>
                </div>
              </li>
            </ul>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from "axios";
import store from "../store";
import { latLng, latLngBounds } from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LTooltip,
  LControl,
  LPolyline,
} from "vue2-leaflet";
import { Icon } from "leaflet";
import GridLoader from "vue-spinner/src/GridLoader.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
export default {
  name: "EditReport",
  props: ["id"],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LControl,
    Icon,
    GridLoader,
    LPolyline,
    PulseLoader,
  },
  created() {
    this.getFilters();
  },
  data() {
    return {
      baseURL: store.state.baseURL,
      time: "",
      show: true,
      horizontal: { label: "col-3", input: "col-9" },
      formCollapsed: true,
      reportError: "",
      photographsToUpload: [],
      postMortemReportToUpload: [],
      newStatus: "",
      redIcon: null,
      greenIcon: null,
      loading: true,
      suggestions: [], // Add this line
      suggestionsrescue: [],
      options: {
        outcomes: [],
        // outcomes : [
        //     "Captive/pending",
        //     "Dead on Arrival",
        //     "Died in captivity",
        //     "Died under care",
        //     "Escaped",
        //     "Pending under care",
        //     "Released",
        //     "Transferred",
        // ],
        zones: [],
        class: [],
        group: [],
        identity: [],
        scientific: [],
        family: [],
        marked: ["Yes", "No"],
        markedType: [
          "Radio Tag",
          "Paint",
          "Ear Tag",
          "Tattoo",
          "Ring/Band",
          "Others",
        ],
        taggingMethods: ["Ear tag", "Ring"],
        collar: ["Radio-collar", "Dummy"],
        radioCollarType: ["VHF", "GPS"],
        postReleaseMonitoring: ["Done", "Not done"],
        mammals: ["Adult", "Subadult", "Juvenile", "Neonate"],
        reptiles: ["Adult", "Subadult", "Juvenile", "Hatchling"],
        aves: ["Mature", "Immature", "Fledgling", "Hatchling"],
        stages: ["Neonate", "Juvenile", "Subadult", "Adult"],
        facilities: [],
        causeOfDisp: [],
        rescueType: ["Field", "Confiscated", "Surrendered"],
        rescuedBy: ["By WTI", "By FD", "By WTI & FD", "Others"],
        broughtBy: ["By WTI", "By FD", "By WTI & FD", "Others"],
        rescueMode: ["In-situ", "Ex-situ"],
        sex: [
          { value: "M", label: "Male" },
          { value: "F", label: "Female" },
          { value: "UK/US", label: "Unknown/Unsexed" },
        ],
      },
      previousDateOfAdmission: "",
      previousDateOfOutcome: "",
      placeOfSecondAdmission: "",
                  selected: {
        class: null,
        family: null,
        group: null,
        identity: null,
        scientific: null,
        caseNumber: null,

        sex: null,
        displacement: null,
        otherreason: null,
        rescueMode: null,
        rescueType: null,
        rescuedBy: null,
        broughtBy: null,
        placeOfRescue: null,
        districtSubDivision: null,
        gpsLatitudeRescue: null,
        gpsLongditudeRescue: null,
        gpsLatRelease: null,
        gpsLongRelease: null,
        zoneName: null,
        dateAdded: null,
        dateOfAdmission: null,
        ageYears: null,
        ageMonths: null,
        stage: null,
        weight: null,
        length: null,
        dateOfOutcome: null,
        dateOfOutcome1: null,
        dateOfRescue: null,
        finalDisposition: null,
        outcomeNotes: null,
        placeOfOutcome: null,
        remarks: null,
        createdBy: null,
        lastUpdatedAt: null,
        lastUpdatedBy: null,
        status: null,
        placeOfSecondAdmission: null,
        dateOfSecondAdmission: null,
        photographs: [],
        taggingMethods: null,
        collar: null,
        radioCollarType: null,
        microchipNumber: null,
        postReleaseMonitoring: null,
        timeSpanOfMonitoring: null,
        outcomeOfMonitoring: null,
        approvalStatus: null,
        rejectionReason: null,
        isMobileCase: false,
        isClosed: false,
        approvedAt: null,
        approvedBy: null,
        closedBy: null,
        editExtensionUntil: null,
      },
    };
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  computed: {
    isOldCase() {
      // Define "old case" as before 2024-01-01 (adjust as needed)
      const threshold = new Date("2024-01-01");
      // If selected.dateAdded not set, default to true (disabled)
      if (!this.selected.dateAdded) return true;
      return new Date(this.selected.dateAdded) < threshold;
    },
  },
  methods: {
    handleClickOutside(event) {
      if (this.$refs.rescueSearchCol) {
        const rescueEl = this.$refs.rescueSearchCol.$el || this.$refs.rescueSearchCol;
        if (rescueEl && !rescueEl.contains(event.target)) {
          this.suggestionsrescue = [];
        }
      }
      if (this.$refs.outcomeSearchCol) {
        const outcomeEl = this.$refs.outcomeSearchCol.$el || this.$refs.outcomeSearchCol;
        if (outcomeEl && !outcomeEl.contains(event.target)) {
          this.suggestions = [];
        }
      }
    },
    toggleCaseStatus() {
      const targetState = !this.selected.isClosed;
      const actionText = targetState ? "close & lock" : "re-open";
      if (!confirm(`Are you sure you want to ${actionText} this case?`)) {
        return;
      }
      this.selected.isClosed = targetState;
      this.updateReport();
    },
    handlePhotoUpload(files) {
      this.photographsToUpload = files;
    },
    handlePostMortemReportUpload(files) {
      this.postMortemReportToUpload = files;
    },
    // validateDates() {
    //     if (this.selected.dateOfAdmission && this.selected.dateOfOutcome) {
    //         const dateOfAdmission = new Date(this.selected.dateOfAdmission);
    //         const dateOfOutcome = new Date(this.selected.dateOfOutcome);

    //         if (dateOfOutcome < dateOfAdmission) {
    //             alert("Date of Outcome must be after Date of Admission");
    //             this.selected.dateOfOutcome = '';
    //         }
    //     }
    // },
    deleteReport() {
      if (
        confirm(
          "Do you want to delete this record? This action cannot be undone!"
        )
      ) {
        this.loading = true;
        axios({
          url: this.baseURL + "records/delete-any-record",
          headers: {
            authorization: store.state.token,
          },
          data: {
            id: this.selected._id,
          },
          method: "POST",
        })
          .then((res) => {
            if (res.data.status) {
              this.$notify({
                group: "notification",
                type: "success",
                title: "Notification",
                text: res.data.message,
              });
              window.close();
            } else {
              this.$notify({
                group: "notification",
                type: "warn",
                title: "Important message",
                text: res.data.message,
              });
              this.loading = false;
            }
          })
          .catch((err) => {
            this.$notify({
              group: "notification",
              type: "error",
              title: "Important message",
              text: "Something went wrong!\\nCouldn't fetch data",
            });
            console.log(err);
            this.reportError = "Something went wrong!\\nCouldn't fetch data";
            this.loading = false;
          });
      }
    },
    updateApprovalStatus(status) {
      let reason = null;
      if (status === "rejected") {
        reason = prompt("Please provide a reason for rejection:");
        if (reason === null) return; // Cancelled
      } else {
        // Validation check before Approval
        // TODO: Re-enable when photographs become compulsory
        // let totalPhotos =
        //   (this.selected.photographs ? this.selected.photographs.length : 0) +
        //   this.photographsToUpload.length;
        // if (totalPhotos < 2) {
        //   this.$notify({
        //     group: "notification",
        //     type: "warn",
        //     title: "Incomplete Data",
        //     text: "Minimum 2 photographs are required before approval.",
        //   });
        //   return;
        // }

        const isProvided = (val) => val !== null && val !== undefined && String(val).trim() !== "" && String(val).trim() !== "null" && String(val).trim() !== "undefined" && String(val).trim() !== "NaN";
        const hasLatRescue = isProvided(this.selected.gpsLatitudeRescue);
        const hasLongRescue = isProvided(this.selected.gpsLongditudeRescue);

        if (hasLatRescue) {
          const latRescue = parseFloat(this.selected.gpsLatitudeRescue);
          if (isNaN(latRescue) || latRescue < -90 || latRescue > 90) {
            this.$notify({
              group: "notification",
              type: "warn",
              title: "Invalid GPS",
              text: "Valid Rescue GPS latitude is required before approval (-90 to 90).",
            });
            return;
          }
        }

        if (hasLongRescue) {
          const longRescue = parseFloat(this.selected.gpsLongditudeRescue);
          if (isNaN(longRescue) || longRescue < -180 || longRescue > 180) {
            this.$notify({
              group: "notification",
              type: "warn",
              title: "Invalid GPS",
              text: "Valid Rescue GPS longitude is required before approval (-180 to 180).",
            });
            return;
          }
        }

        if (
          !confirm(
            `Are you sure you want to approve this case? It will move to Existing Cases.`
          )
        )
          return;
      }

      this.loading = true;
      axios({
        url: this.baseURL + "records/update-approval",
        headers: {
          authorization: store.state.token,
        },
        method: "POST",
        data: {
          id: this.selected._id,
          status: status,
          reason: reason
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.$notify({
              group: "notification",
              type: "success",
              title: status.charAt(0).toUpperCase() + status.slice(1) + "!",
              text: `Case has been ${status} successfully.`,
            });
            this.selected.approvalStatus = status;
            if (status === 'approved') {
              this.selected.status = 'uploaded';
              this.selected.rejectionReason = null;
            } else {
              this.selected.rejectionReason = reason;
            }
          } else {
            this.$notify({
              group: "notification",
              type: "error",
              title: "Error",
              text: res.data.message,
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$notify({
            group: "notification",
            type: "error",
            title: "Error",
            text: `Something went wrong while ${status} the case.`,
          });
          console.log(err);
          this.loading = false;
        });
    },
    updateReport() {
      // TODO: Re-enable when photographs become compulsory
      // let totalPhotos =
      //   (this.selected.photographs ? this.selected.photographs.length : 0) +
      //   this.photographsToUpload.length;
      // if (totalPhotos < 2) {
      //   this.$notify({
      //     group: "notification",
      //     type: "warn",
      //     title: "Incomplete Data",
      //     text: "Minimum 2 photographs are required to update the record.",
      //   });
      //   this.loading = false;
      //   return;
      // }

      if (this.selected.placeOfRescue) {
        this.selected.placeOfRescue = this.selected.placeOfRescue.trim();
        if (this.selected.placeOfRescue === "") {
          this.selected.placeOfRescue = null;
        }
      } else {
        this.selected.placeOfRescue = null;
      }


      // --- Add logic for displacement Others
      if (this.selected.displacement === "Others") {
        this.selected.displacement = this.selected.otherreason;
      }
      // ---
      if (this.selected.dateOfOutcome != this.selected.dateOfOutcome1) {
        if (this.selected.dateOfAdmission && this.selected.dateOfOutcome) {
          const dateOfAdmission = new Date(this.selected.dateOfAdmission);
          const dateOfOutcome = new Date(this.selected.dateOfOutcome);

          if (dateOfOutcome < dateOfAdmission) {
            alert("Date of Outcome must be after Date of Admission");

            this.loading = false;
            return;
          }
        }
      }
      this.loading = true;

      let formData = new FormData();
      for (let i = 0; i < this.photographsToUpload.length; i++) {
          formData.append('photographs', this.photographsToUpload[i]);
      }
      if (this.postMortemReportToUpload.length > 0) {
        formData.append('postMortemReport', this.postMortemReportToUpload[0]);
      }

      for (const key in this.selected) {
          if (this.selected.hasOwnProperty(key) && key !== 'photographs') {
              let value = this.selected[key];
              if (value === null || value === undefined) continue;
              formData.append(key, value);
          }
      }

      axios({
        url: this.baseURL + "records/update-any-record",
        headers: {
          authorization: store.state.token,
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
        method: "POST",
      })
        .then((res) => {
          if (res.data.status) {
            this.$notify({
              group: "notification",
              type: "success",
              title: "Notification",
              text: res.data.message,
            });

            this.getReport();
          } else {
            this.$notify({
              group: "notification",
              type: "warn",
              title: "Important message",
              text: res.data.message,
            });
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$notify({
            group: "notification",
            type: "error",
            title: "Important message",
            text: "Something went wrong!\\nCouldn't fetch data",
          });
          console.log(err);
          this.reportError = "Something went wrong!\\nCouldn't fetch data";
          this.loading = false;
        });
    },
    getReport() {
      this.loading = true;
      axios({
        url: this.baseURL + "records/get-one/" + this.id,
        headers: {
          authorization: store.state.token,
        },
        method: "GET",
      })
        .then((res) => {
          if (res.data.status) {
            this.selected = res.data.data;
            if (res.data.data.animalData != null) {
              this.selected.class = res.data.data.animalData.class;
              this.selected.group = res.data.data.animalData.categoryName;
              this.selected.identity = res.data.data.animalData.identityName;
              this.selected.family = res.data.data.animalData.groupName;
              this.selected.scientific =
                res.data.data.animalData.scientificName;
            }
            
            if (this.selected.editExtensionUntil) {
              try {
                // Format for datetime-local input (YYYY-MM-DDTHH:mm) using local time
                const d = new Date(this.selected.editExtensionUntil);
                const pad = (n) => n.toString().padStart(2, '0');
                this.selected.editExtensionUntil = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
              } catch (e) {
                console.error("Error formatting extension date", e);
              }
            }
            
            if (this.selected.displacement) {
              const officialOptions = this.options.causeOfDisp.map(opt => (typeof opt === 'object' && opt.value) ? opt.value : opt);
              if (officialOptions.indexOf(this.selected.displacement) === -1) {
                this.selected.otherreason = this.selected.displacement;
                this.selected.displacement = "Others";
              } else {
                this.selected.otherreason = null;
              }
            }

            if (this.selected.dateOfAdmission)
              this.selected.dateOfAdmission =
                this.selected.dateOfAdmission.substr(0, 10);

            if (this.selected.dateOfRescue)
              this.selected.dateOfRescue = this.selected.dateOfRescue.substr(
                0,
                10
              );

            if (this.selected.dateOfOutcome) {
              this.selected.dateOfOutcome = this.selected.dateOfOutcome.substr(
                0,
                10
              );
              this.selected.dateOfOutcome1 = this.selected.dateOfOutcome.substr(
                0,
                10
              );
            }

 
            if (this.selected.dateOfSecondAdmission) {
              this.selected.dateOfSecondAdmission = this.selected.dateOfSecondAdmission.substr(0, 10);
            }
            if ('placeOfSecondAdmission' in res.data.data) {
              this.selected.placeOfSecondAdmission = res.data.data.placeOfSecondAdmission;
            }
            this.updateFilters();
            this.loading = false;
          } else {
            this.$notify({
              group: "notification",
              type: "warn",
              title: "Important message",
              text: res.data.message,
            });
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$notify({
            group: "notification",
            type: "error",
            title: "Important message",
            text: "Something went wrong!\\nCouldn't fetch data",
          });
          console.log(err);
          this.loading = false;
          this.reportError = "Something went wrong!\\nCouldn't fetch data";
        });
    },
    getFilters() {
      this.loading = true;
      axios({
        url: this.baseURL + "records/filters",
        headers: {
          authorization: store.state.token,
        },
        data: {
          class: this.selected.class != null ? this.selected.class : null,
        },
        method: "POST",
      })
        .then((res) => {
          if (res.data.status) {
            this.options.outcomes = res.data.data.outcomes;
            // this.options.facilities = res.data.data.facilities;
            // this.options.stages = res.data.data.stages;
            this.options.class = res.data.data.classes;
            this.options.zones = res.data.data.zones;
            this.options.causeOfDisp = res.data.data.displacement;
            // this.options.group = res.data.data.group;
            // this.options.identity = res.data.data.identity;
            // this.options.family = res.data.data.family;
            // this.options.scientific = res.data.data.scientific;
            this.getReport();
          } else {
            this.items = [];
            this.tableLength = 0;
            this.$notify({
              group: "notification",
              type: "error",
              title: "Important message",
              text: res.data.message,
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$notify({
            group: "notification",
            type: "error",
            title: "Important message",
            text: "Error in loading data. Something went wrong!",
          });
          console.log(err);
          this.loading = false;
          return [];
        });
    },
    updateIdentityNames(type) {
      console.log(type);
      if (type == "identity") {
        this.selected.scientific = null;
      } else {
        this.selected.identity = null;
      }
    },
    updateFilters(type) {
      this.loading = true;

      if (type == "family") {
        this.selected.family = null;
        this.selected.group = null;
      } else if (type == "group") {
        this.selected.group = null;
      }

      axios({
        url: this.baseURL + "records/filters/animal",
        headers: {
          authorization: store.state.token,
        },
        data: {
          class: this.selected.class,
          family: this.selected.family != null ? this.selected.family : null,
          group: this.selected.group != null ? this.selected.group : null,
          type: type,
        },
        method: "POST",
      })
        .then((res) => {
          if (res.data.status) {
            console.log(res.data);
            // this.options.class = res.data.data.class;
            this.options.group = res.data.data.group;
            this.options.identity = res.data.data.identity;
            this.options.family = res.data.data.family;
            this.options.scientific = res.data.data.scientific;
          } else {
            this.$notify({
              group: "notification",
              type: "error",
              title: "Important message",
              text: res.data.message,
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$notify({
            group: "notification",
            type: "error",
            title: "Important message",
            text: "Error in loading data. Something went wrong!",
          });
          console.log(err);
          this.loading = false;
          return [];
        });
    },
    onInputrescue() {
      if (this.selected.placeOfRescue.length >= 4) {
        this.fetchSuggestionsrescue(this.selected.placeOfRescue);
      } else {
        this.suggestionsrescue = [];
      }
    },
    onInput() {
      if (this.selected.placeOfOutcome.length >= 4) {
        this.fetchSuggestions(this.selected.placeOfOutcome);
      } else {
        this.suggestions = [];
      }
    },
    fetchSuggestions(keyword) {
      this.loading = true;
      axios({
        url: this.baseURL + "analytics/placeofoutcome-wise",
        headers: {
          authorization: store.state.token,
        },
        data: {
          placeOfOutcome: keyword,
        },
        method: "POST",
      })
        .then((res) => {
          if (res.data.status) {
            this.suggestions = res.data.data;
          } else {
            this.$notify({
              group: "notification",
              type: "error",
              title: "Important message",
              text: res.data.message,
            });
            this.suggestions = [];
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$notify({
            group: "notification",
            type: "error",
            title: "Important message",
            text: "Error in loading data. Something went wrong!",
          });
          console.log(err);
          this.loading = false;
          this.suggestions = [];
        });
    },
    fetchSuggestionsrescue(keyword) {
      this.loading = true;
      axios({
        url: this.baseURL + "analytics/placeofrescue-wise",
        headers: {
          authorization: store.state.token,
        },
        data: {
          placeOfRescue: keyword,
        },
        method: "POST",
      })
        .then((res) => {
          if (res.data.status) {
            this.suggestionsrescue = res.data.data;
          } else {
            this.$notify({
              group: "notification",
              type: "error",
              title: "Important message",
              text: res.data.message,
            });
            this.suggestionsrescue = [];
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$notify({
            group: "notification",
            type: "error",
            title: "Important message",
            text: "Error in loading data. Something went wrong!",
          });
          console.log(err);
          this.loading = false;
          this.suggestionsrescue = [];
        });
    },
    handleSelect(item) {
      this.selected.placeOfOutcome = item.value;
    },
    selectSuggestion(suggestion) {
      this.selected.placeOfOutcome = suggestion;
      this.suggestions = [];
    },
    selectSuggestionrescue(suggestions) {
      this.selected.placeOfRescue = suggestions;
      this.suggestionsrescue = [];
    },
  },
};
</script>
<style scoped>
table,
th,
td {
  border: 1px solid black;
}
.suggestions-dropdown {
  position: absolute;
  top: 100%;
  left: 15px;
  right: 15px;
  z-index: 1050;
  background: #ffffff;
  border: 1px solid #ced4da;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 220px;
  overflow-y: auto;
  margin-top: -6px;
  padding: 0;
  list-style: none;
}

.suggestion-item {
  padding: 8px 12px;
  font-size: 0.9rem;
  color: #3c4b64;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.15s ease-in-out;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.suggestion-item:hover {
  background-color: #e8f4fe;
  color: #20a8d8;
  font-weight: 500;
}
.timeline-list {
  list-style: none;
  position: relative;
  padding-left: 0px;
}
.timeline-list::before {
  content: '';
  position: absolute;
  left: 11px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #ebedef;
}
.timeline-item {
  position: relative;
  display: flex;
  align-items: flex-start;
  z-index: 1;
}
.timeline-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  color: white;
  flex-shrink: 0;
  font-size: 10px;
}
.timeline-title {
  font-weight: bold;
  font-size: 0.9rem;
  line-height:1.2;
}
.timeline-date {
  font-size: 0.75rem;
  color: #768192;
}
.timeline-user {
  font-size: 0.75rem;
  color: #4f5d73;
}
</style>